import { graphql } from 'react-relay';

export const hpSharedFeaturedItemsQuery = graphql`
    query HpSharedFeaturedItemsQuery(
        $userId: String!
        $hasUserId: Boolean!
        $personalizationId: String = ""
        $guestId: String = ""
        $isTrade: Boolean!
        $priceBookName: String!
        $minSponsoredItemsSteps: [Int!]
    ) {
        viewer {
            ...HpSharedFeaturedItemsCarousel_viewer
        }
    }
`;
